module.exports = __webpack_public_path__ + "img/7.0_News_10_Sharynne-Hamilton@2x.b6b6b7353077867d8c71f5cbb46c31b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_10_Sharynne-Hamilton@2x.png
// module id = 795
// module chunks = 0